import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { deleteModelHierarchy } from 'actions/userActions';

export const DeleteModelHrcyDialog = ({ onClose, open, selectedRow, email }) => {
    const dispatch = useDispatch();

    const handleDelete = () => {
        dispatch(deleteModelHierarchy(selectedRow.kmatId, selectedRow.region, email));
        onClose();
    };

    const textStyle = { color: 'error.main', fontSize: 17, ml: 1, display: 'inline-block' };

    return (
        <Dialog className="custom-dialog" open={open} onClose={onClose}>
            <DialogTitle variant="h6">Delete Model Details</DialogTitle>
            <DialogContent sx={{ fontSize: 19, mb: 2 }} dividers>
                You are about to delete&nbsp;
                <Typography sx={textStyle}>{selectedRow?.modelName}</Typography>
                &nbsp;for kmat&nbsp;
                <Typography sx={textStyle}>{selectedRow?.kmatId}</Typography>
                &nbsp;in&nbsp;
                <Typography sx={textStyle}>{selectedRow?.region}</Typography>
                &nbsp;region.<br />
                Are you sure? This process can't be undone.
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose} className="cancel-button">Cancel</Button>
                <Button onClick={handleDelete} className="delete-button">Delete</Button>
            </DialogActions>
        </Dialog>
    );
}